import { Component } from '@angular/core';

@Component({
  selector: 'app-aviso-atividade-jornada',
  templateUrl: './aviso-atividade-jornada.component.html',
  styleUrls: ['./aviso-atividade-jornada.component.scss'],
  standalone: true
})
export class AvisoAtividadeJornadaComponent {}
